import { ApolloError } from '@apollo/client';

import { useCareerMemberLearningProgressQuery } from 'core/graphql';

import { ICareerMemberLessonProgress } from './careerModel';

// Stable empty fallback — see the note in `useCareerMembers`.
const EMPTY_PROGRESS: ICareerMemberLessonProgress[] = [];

interface ICareerMemberProgressHook {
  progress: ICareerMemberLessonProgress[];
  loading: boolean;
  error?: ApolloError;
}

/**
 * Spec 0020 Фаза B — one member's per-lesson learning map for the progress
 * drawer (`careerMemberProgress`). Skips while `memberId` is empty so a closed
 * drawer fires no query; `cache-and-network` refreshes a reopened drawer after
 * the graduate studies more.
 */
export const useCareerMemberProgress = (
  memberId?: string | null,
): ICareerMemberProgressHook => {
  const { data, loading, error } = useCareerMemberLearningProgressQuery({
    variables: { memberId: memberId ?? '' },
    skip: !memberId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    progress: data?.careerMemberProgress ?? EMPTY_PROGRESS,
    loading,
    error,
  };
};
